import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = getFeaturedArticles();

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 md:mb-14 gap-4">
          <div>
            <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-4 font-label">
              精选文章
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
              必读热门内容
            </h2>
          </div>
          <Link
            to="/category/training-moves"
            className="text-primary-600 text-sm font-medium flex items-center gap-1 hover:gap-2 transition-all whitespace-nowrap"
          >
            全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featured.slice(0, 3).map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group block bg-background-50 rounded-lg border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full">
                    推荐
                  </span>
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {article.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                </div>
                <h3 className="text-foreground-900 font-semibold text-base leading-snug mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-foreground-600 text-xs leading-relaxed line-clamp-2 mb-4">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-500">{article.author}</span>
                  <span className="text-primary-600 text-xs font-medium flex items-center gap-1 group-hover:gap-2 transition-all">
                    阅读全文
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {featured.length > 3 && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
            {featured.slice(3).map((article) => (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group flex flex-col sm:flex-row gap-4 bg-background-50 rounded-lg border border-background-200/60 p-4 hover:border-primary-200 transition-all duration-300"
              >
                <div className="w-full sm:w-40 h-28 flex-shrink-0 rounded-md overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
                    <span>{article.date}</span>
                    <span>{article.readTime}</span>
                  </div>
                  <h3 className="text-foreground-900 font-semibold text-sm leading-snug mb-1 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-foreground-600 text-xs leading-relaxed line-clamp-2">
                    {article.excerpt}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}